import { NextRequest, NextResponse } from 'next/server';

export function homeRouteHandler(_req: NextRequest): NextResponse {
  // TODO: Implement home route handler
  return NextResponse.next();
}